import { PatientThreadAssignee } from "@accurx/api/ticket";
import { PatientExternalId } from "@accurx/native";
import { api } from "domains/concierge/internal/api/ticket";
import { AddTicketReponse } from "domains/concierge/internal/api/ticket/TicketApiClient";
import { useConciergeMeta } from "domains/concierge/internal/context";
import {
    UseMutationOptions,
    useMutation,
} from "domains/concierge/internal/util/useMutation";

type Variables = {
    patientIds: PatientExternalId[];
    assignee: PatientThreadAssignee;
    note: string;
};

export const useCreateTicketWithNoteMutation = (
    options?: UseMutationOptions<Variables, AddTicketReponse>,
) => {
    const { workspaceId } = useConciergeMeta();
    return useMutation<Variables, AddTicketReponse>(
        "createTicketWithNote",
        async ({ patientIds, assignee, note }) => {
            const { response } = await api.createTicketWithNote({
                workspaceId,
                patientIds,
                assignee,
                note,
            });

            return response;
        },
        options,
    );
};
